import { useMutation } from '@tanstack/react-query'
import requestPatchEmployeeCreditCustomerId, { EMPLOYEE_CREDIT_CUSTOMER_UPDATE_ERRORS } from 'businessTraveller/api/requestPatchEmployeeCreditCustomerId'
import requestPatchMyCreditCustomerId from 'businessTraveller/api/requestPatchMyCreditCustomerId'

interface BusinessTravellerEmployeeCustomerCreditIdUpdateVariables {
  accessToken: string
  businessId: string
  creditCustomerEmail?: string
  creditCustomerId: string
  employeeId: string
}

interface Params {
  onSuccess?: () => void
  // When on, link via the self-service /me endpoint (gated by lebt_dedicated_tenant_registration).
  useSelfServiceEndpoint?: boolean
}

function useBusinessTravellerCreditCustomerUpdateMutation(params: Params) {
  const {
    onSuccess,
    useSelfServiceEndpoint = false,
  } = params

  const creditCustomerIdUpdateMutation = useMutation<boolean, EMPLOYEE_CREDIT_CUSTOMER_UPDATE_ERRORS, BusinessTravellerEmployeeCustomerCreditIdUpdateVariables>({
    mutationFn: (variables) => {
      const {
        accessToken,
        businessId,
        creditCustomerId,
        creditCustomerEmail,
        employeeId,
      } = variables

      if (useSelfServiceEndpoint) {
        return requestPatchMyCreditCustomerId({ businessId, linkedAccountToken: accessToken })
      }

      return requestPatchEmployeeCreditCustomerId(
        { businessId, employeeId },
        { creditCustomerId, creditCustomerEmail },
        accessToken,
      )
    },
    onSuccess: (data) => {
      if (data) {
        onSuccess?.()
      }
    },
  })

  return creditCustomerIdUpdateMutation
}

export default useBusinessTravellerCreditCustomerUpdateMutation
